import React from 'react';

import {ReactComponent as WarningEmpty} from '../../assets/kinologyIcons/svg/warningInvoices.svg';

const EmptyComponent: React.FC = ()=> {
	return (
		<div className={`flex flex-col w-5/12 justify-center text-[#3D4259] text-center font-bold `}>
			<div className={`self-center mb-[14px]`}>
				<WarningEmpty className={`h-5 w-5`} color={`#3D4259`}/>
			</div>
			Não há dados disponíveis nesse gráfico para o filtro aplicado. 
		</div>
	)
};
export default EmptyComponent;